import React from "react";
import { FaAllergies } from "react-icons/fa";
import useSystemVariable from "./shared/useSystemVariable";
import SystemVariablePage from "./shared/SystemVariablePage";
import { normalizeHeader, pickCell, downloadExcelTemplate } from "./shared/excelUtils";
import {
  useListAllergiesMutation, useCreateAllergyMutation,
  useUpdateAllergyMutation, useDeleteAllergyMutation,
  useBulkUpsertAllergiesMutation,
} from "../../store/systemVariablesApi";

const mapExcelRow = (row) => {
  const n = {};
  Object.keys(row || {}).forEach((k) => { n[normalizeHeader(k)] = row[k]; });
  const name = pickCell(n, ["alerji", "alerji adı", "alerji adi", "ad", "name"]);
  return { name: name ? String(name).trim() : "" };
};

const TEMPLATE_ROWS = [
  { Alerji: "Penisilin" }, { Alerji: "Polen" }, { Alerji: "Toz akarı" },
  { Alerji: "Fıstık" }, { Alerji: "Süt" }, { Alerji: "Yumurta" },
  { Alerji: "Lateks" }, { Alerji: "Aspirin" }, { Alerji: "Arı sokması" }, { Alerji: "Kedi tüyü" },
];

export default function Allergies() {
  const vm = useSystemVariable({
    listMutation: useListAllergiesMutation(),
    createMutation: useCreateAllergyMutation(),
    updateMutation: useUpdateAllergyMutation(),
    deleteMutation: useDeleteAllergyMutation(),
    bulkMutation: useBulkUpsertAllergiesMutation(),
    itemsKey: "items",
    idKey: "allergyId",
    defaultForm: { name: "" },
    itemToForm: (it) => ({ name: it?.name || "" }),
    formToPayload: (form) => ({ name: form.name }),
    entityLabel: "Alerji",
  });

  return (
    <SystemVariablePage
      icon={<FaAllergies size={22} />}
      title="Alerjiler"
      subtitle={<>Excel yükleme: <b>Alerji</b> veya <b>Alerji Adı</b> sütunu</>}
      entityLabel="Alerji"
      vm={vm}
      tableColumns={[{ key: "name", label: "Alerji", bold: true }]}
      formFields={[{ key: "name", label: "Alerji adı", required: true }]}
      importColumns={[{ key: "name", label: "Alerji", bold: true }]}
      mapExcelRow={mapExcelRow}
      downloadTemplate={() => downloadExcelTemplate(TEMPLATE_ROWS, "Alerjiler", "alerji_sablonu.xlsx")}
    />
  );
}
